import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Avatar, Button, Portal, Text, VStack, chakra, Spinner, Box, Heading, HStack, Icon, Link, Separator, Center, HoverCard } from '@chakra-ui/react';
import { SlateNode } from '@src/components/sco/RichMarkdownInput';
import { Mentionable } from '@src/components/sco/RichMarkdownInput/plugins/mentions';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ScoUser } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import moment from 'moment/moment';
import React from 'react';
import { LuBriefcase, LuClock, LuLink, LuTags } from 'react-icons/lu';
import { useFocused, useSelected } from 'slate-react';
export type MentionElementProps = {
  attributes?: any;
  children?: any;
  element?: SlateNode & {
    mentionable?: {
      label: string;
      identifier: string;
    };
    type?: 'mention';
  };
};
export function MentionElement(props) {
  const $ = _c(16);
  useFocused();
  useSelected();
  let t0;
  if ($[0] !== props.element.mentionable.identifier) {
    t0 = props.element.mentionable.identifier?.replace("mention:user:", "");
    $[0] = props.element.mentionable.identifier;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const userId = t0;
  let t1;
  if ($[2] !== props.element.mentionable.identifier) {
    t1 = props.element.mentionable.identifier?.replaceAll(":", "-");
    $[2] = props.element.mentionable.identifier;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = `mention-${t1}`;
  const t3 = `/members/${userId}`;
  let t4;
  if ($[4] !== props.attributes || $[5] !== props.children || $[6] !== props.element.mentionable.label || $[7] !== t2 || $[8] !== t3) {
    t4 = <HoverCard.Trigger asChild={true}><chakra.a contentEditable={false} data-cy={t2} href={t3} target="_blank" textDecoration="none" {...props.attributes}>{props.children}@{props.element.mentionable.label}</chakra.a></HoverCard.Trigger>;
    $[4] = props.attributes;
    $[5] = props.children;
    $[6] = props.element.mentionable.label;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props.element.mentionable || $[11] !== userId) {
    t5 = <Portal><HoverCard.Positioner><HoverCard.Content backdropBlur="sm" backdropFilter="auto" border="none" borderRadius="xl" boxShadow="sm" maxWidth="280px" padding={3}><MentionUserProfile mentionable={props.element.mentionable} userId={userId} /></HoverCard.Content></HoverCard.Positioner></Portal>;
    $[10] = props.element.mentionable;
    $[11] = userId;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <HoverCard.Root>{t4}{t5}</HoverCard.Root>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
const MentionUserProfile = props => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($userId: String!) {
        userById(userId: $userId) {
          id
          fullName
          displayName
          shortBio
          company {
            id
            name
            industryKey
            elevatorPitch
          }
          lastActiveAt
          pictureUrl
          userId
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.userId) {
    t1 = {
      variables: {
        userId: props.userId
      },
      ssr: false
    };
    $[1] = props.userId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t0, t1);
  let t2;
  if ($[3] !== props.mentionable?.label || $[4] !== query.data?.userById || $[5] !== query.loading) {
    const user = query.data?.userById || {
      fullName: props.mentionable?.label
    };
    t2 = <Box fontSize="12px"><HStack borderBottom="1px" borderBottomColor="whiteAlpha.200" gap={2} marginBottom="1em" paddingBottom="1em" width="full"><Avatar.Root size="sm"><Avatar.Fallback name={user.fullName} /><Avatar.Image src={user.pictureUrl} /></Avatar.Root><Heading flexGrow={1} fontSize="1.2em">{user.fullName || user.displayName}</Heading></HStack>{query.loading ? <Center><Spinner /></Center> : <VStack align="stretch"><HStack align="flex-start"><Icon asChild={true} marginTop="4px" width="1em"><LuBriefcase /></Icon><Box><Text fontWeight={900}><strong>{user.company?.name || "N/A"}</strong></Text></Box></HStack><HStack align="flex-start"><Icon asChild={true} marginTop="4px" width="1em"><LuLink /></Icon><Text width="full"><Link href={user.company?.url || null} variant="underline">{user.company?.url || "N/A"}</Link></Text></HStack><HStack align="flex-start"><Icon asChild={true} marginTop="4px" width="1em"><LuTags /></Icon><Text width="full">{user.company?.industryKey || "N/A"}</Text></HStack><HStack align="flex-start"><Icon asChild={true} marginTop="4px" width="1em"><LuClock /></Icon><Text width="full">{"Last seen "}{moment(user.lastActiveAt || null).fromNow()}</Text></HStack><Separator /><Button asChild={true} size="sm"><NextLink href={`/members/${user.userId}`} target="_blank">View Profile</NextLink></Button></VStack>}</Box>;
    $[3] = props.mentionable?.label;
    $[4] = query.data?.userById;
    $[5] = query.loading;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};